import { jsx as e, Fragment as a } from "@emotion/react/jsx-runtime";
import { DocumentThumb as p } from "../DocumentThumb/DocumentThumb.js";
const u = ({
  files: n,
  removeFile: r
}) => {
  const t = (m, o) => {
    m.stopPropagation(), r(o);
  };
  return /* @__PURE__ */ e(a, { children: n.map((m) => /* @__PURE__ */ e(p, { file: m, remove: (o) => t(o, m.name) }, m.name)) });
};
export {
  u as DocumentThumbs
};
